/* eslint-disable max-lines */
import React, { lazy } from 'react';

import ModalService from 'services/ModalService';
import AdminBannedUserModal from 'pages/AdminBannedUsers/AdminBnnedUserModal';
import AdminBulkBanModal from 'pages/AdminBulkBan/AdminBulkBanModal';
import AdminConfirmModal from 'pages/AdminPrivateShowRatings/AdminConfirmModal';
import DMCASubmitModal from 'components/DMCASubmitModal/DMCASubmitModal';
import OneClickRetentionModal from 'components/OneClickRetentionModal/OneClickRetentionModal';
import Safari14Modal from 'components/Safari14Modal/Safari14Modal';
import SendUserGiftModal from 'components/SendUserGift/SendUserGiftModal';
import ShaftTrafficAdsModal from 'components/ShaftTrafficAdsModal';


const PorndoeModal = lazy(() => import('../PorndoeModal/PorndoeModal'));
const NonPurchasedOverlay = lazy(() => import('pages/UserProfile/FanClub/MediaSection/Overlays/NonPurchasedOverlay'));
const FanclubVideoOverlay = lazy(() => import('pages/UserProfile/FanClub/MediaSection/Overlays/FanclubVideoOverlay'));

const WebRTCOBSIncorrectConfigModal = lazy(() =>
  import('components/WebRTCOBSIncorrectConfigModal')
);
const AddBroadcasterToSponsoredTagModal = lazy(() =>
  import('components/AddBroadcasterToSponsoredTagModal/AddBroadcasterToSponsoredTagModal')
);
const AddNewTagModal = lazy(() =>
  import('components/AddNewTagModal/AddNewTagModal')
);
const AddStudioBroadcastersToTagModal = lazy(() =>
  import('components/AddStudioBroadcastersToTagModal/AddStudioBroadcastersToTagModal')
);
const AdminCsvMessagesModal = lazy(() =>
  import('pages/AdminCsvMessages/AdminCsvMessagesModal')
);
const AdminLanguageOverrideModal = lazy(() =>
  import('pages/AdminLanguageOverride/AdminLanguageOverrideModal')
);
const AllGiftsModal = lazy(() =>
  import('components/AllGiftsModal/AllGiftsModal')
);
const AutoReloadModal = lazy(() =>
  import('components/AutoReloadModal/AutoReloadModal')
);
const AwardsModal = lazy(() =>
  import('components/AwardsModal/AwardsModal')
);
const BasicRedirectOnboardingModal = lazy(() =>
  import('components/BasicRedirectOnboardingModal/BasicRedirectOnboardingModal')
);
const BeatTheLeaderModal = lazy(() =>
  import('components/BeatTheLeaderModal/BeatTheLeaderModal')
);
const BeatTipLeaderModal = lazy(() =>
  import('components/BeatTipLeaderModal/BeatTipLeaderModal')
);
const BoostModal = lazy(() =>
  import('components/BoostModal/BoostModal')
);
const BroadcasterCancelGroupShowModal = lazy(() =>
  import('pages/Broadcaster/Modals/BroadcasterCancelGroupShowModal/BroadcasterCancelGroupShowModal')
);
const BroadcasterEndPrivateShowModal = lazy(() =>
  import('pages/Broadcaster/Modals/BroadcasterEndPrivateShowModal/BroadcasterEndPrivateShowModal')
);
const BroadcasterConnectToyModal = lazy(() =>
  import('pages/Broadcaster/Modals/BroadcasterConnectToyModal/BroadcasterConnectToyModal')
);
const BroadcasterGroupShowLastChance = lazy(() =>
  import('pages/Broadcaster/Modals/BroadcasterGroupShowLastChance/BroadcasterGroupShowLastChance')
);
const BroadcasterGroupShowTimeReachedModal = lazy(() =>
  import('pages/Broadcaster/Modals/BroadcasterGroupShowTimeReachedModal/BroadcasterGroupShowTimeReachedModal')
);
const BroadcasterGSSettingsModal = lazy(() =>
  import('pages/Broadcaster/Modals/BroadcasterGSSettingsModal/BroadcasterGSSettingsModal')
);
const BroadcasterMessageDisabledModal = lazy(() =>
  import('components/BroadcasterMessageDisabledModal/BroadcasterMessageDisabledModal')
);
const BroadcasterPSEndedRatingModal = lazy(() =>
  import('pages/Broadcaster/Modals/BroadcasterPSEndedRatingModal/BroadcasterPSEndedRatingModal')
);
const BroadcasterTicketGoalReachedModal = lazy(() =>
  import('pages/Broadcaster/Modals/BroadcasterTicketGoalReachedModal/BroadcasterTicketGoalReachedModal')
);
const BroadcasterWindowIntroductionModal = lazy(() =>
  import('pages/Broadcaster/Modals/BroadcasterWindowIntroductionModal/BroadcasterWindowIntroductionModal')
);
const BroadcastEndModal = lazy(() =>
  import('pages/Broadcaster/Modals/BroadcastEndModal/BroadcastEndModal')
);
const BroadcastErrorModal = lazy(() =>
  import('pages/Broadcaster/Modals/BroadcastErrorModal/BroadcastErrorModal')
);
const BroadcastingConsentModal = lazy(() =>
  import('components/BroadcastingConsentModal/BroadcastingConsentModal')
);
const BroadcastMobileConsentModal = lazy(() =>
  import('components/BroadcastMobileConsentModal/BroadcastMobileConsentModal')
);
const BroadcastOBSVirtualCameraWarningModal = lazy(() =>
  import('pages/Broadcaster/Modals/BroadcastOBSVirtualCameraWarningModal/BroadcastOBSVirtualCameraWarningModal')
);
const BroadcastTypeOnboardingModal = lazy(() =>
  import('components/BroadcastTypeOnboardingModal/BroadcastTypeOnboardingModal')
);
const BuyAllVideosModal = lazy(() =>
  import('components/BuyAllVideosModal/BuyAllVideosModal')
);
const BuyGiftsModal = lazy(() =>
  import('components/BuyGiftsModal/BuyGiftsModal')
);
const CampaignOverlayMobile = lazy(() =>
  import('components/CampaignOverlayMobile/CampaignOverlayMobile')
);
const CashOutRestrictedModal = lazy(() =>
  import('components/CashOutRestrictedOrNeedsIdModal/CashOutRestrictedModal')
);
const ChatContextualMenuBan = lazy(() =>
  import('components/ChatContextualMenuBan/ChatContextualMenuBan')
);
const ChatContextualMenuConfirmOption = lazy(() =>
  import('components/ChatContextualMenuConfirmOption/ChatContextualMenuConfirmOption')
);
const ChatContextualMenuKick = lazy(() =>
  import('components/ChatContextualMenuKick/ChatContextualMenuKick')
);
const ChatContextualMenuCloseRoom = lazy(() =>
  import('components/ChatContextualMenuCloseRoom/ChatContextualMenuCloseRoom')
);
const ChatContextualMenuDeleteKick = lazy(() =>
  import('components/ChatContextualMenuDeleteKick/ChatContextualMenuDeleteKick')
);
const ChatContextualMenuFanBan = lazy(() =>
  import('components/ChatContextualMenuFanBan/ChatContextualMenuFanBan')
);
const ChatContextualMenuFanPermaBan = lazy(() =>
  import('components/ChatContextualMenuFanPermaBan/ChatContextualMenuFanPermaBan')
);
const ChatContextualMenuFeatureBroadcaster = lazy(() =>
  import('components/ChatContextualMenuFeatureBroadcaster/ChatContextualMenuFeatureBroadcaster')
);
const ChatContextualMenuPermaBan = lazy(() =>
  import('components/ChatContextualMenuPermaBan/ChatContextualMenuPermaBan')
);
const ChatContextualMenuReport = lazy(() =>
  import('components/ChatContextualMenuReport/ChatContextualMenuReport')
);
const ChatContextualOverlay = lazy(() =>
  import('components/ChatContextualOverlay/ChatContextualOverlay')
);
const CloseConversationModal = lazy(() =>
  import('components/CloseConversationModal/CloseConversationModal')
);
const ComingSoonModal = lazy(() =>
  import('components/ComingSoonModal/ComingSoonModal')
);
const ContinuePurchaseOrJoinFanclubModal = lazy(() =>
  import('pages/UserProfile/FanClub/MediaSection/Overlays/ContinuePurchaseOrJoinFanclubModal')
);
const DeleteCommentModal = lazy(() =>
  import('components/DeleteCommentModal/DeleteCommentModal')
);
const DeleteModal = lazy(() =>
  import('components/DeleteModal/DeleteModal')
);
const DeleteSponsoredTagModal = lazy(() =>
  import('components/DeleteSponsoredTagModal/DeleteSponsoredTagModal')
);
const DisableShowInvitesModal = lazy(() =>
  import('components/DisableShowInvitesModal/DisableShowInvitesModal')
);
const ErrorModal = lazy(() =>
  import('components/ErrorModal/ErrorModal')
);
const GiftModal = lazy(() =>
  import('pages/AdminGifts/GiftModal')
);
const GiftCategoryModal = lazy(() =>
  import('pages/AdminGifts/GiftCategoryModal')
);
const GroupShowBuyTicketModal = lazy(() =>
  import('components/GroupShowBuyTicketModal/GroupShowBuyTicketModal')
);
const GroupShowCanceledModal = lazy(() =>
  import('components/GroupShowCanceledModal/GroupShowCanceledModal')
);
const GroupShowGoalModal = lazy(() =>
  import('components/GroupShowGoalModal/GroupShowGoalModal')
);
const GroupShowGoalReachedModal = lazy(() =>
  import('components/GroupShowGoalReachedModal/GroupShowGoalReachedModal')
);
const GuestBillingModal = lazy(() =>
  import('components/GuestBillingModal/GuestBillingModal')
);
const GuestRegistrationModal = lazy(() =>
  import('pages/UserProfile/FanClub/GuestRegistrationModal/index')
);
const InformMultipleIdentitiesOnboardingModal = lazy(() =>
  import('components/InformMultipleIdentitiesOnboardingModal/InformMultipleIdentitiesOnboardingModal')
);
const InformPendingOnboardingModal = lazy(() =>
  import('components/InformPendingOnboardingModal/InformPendingOnboardingModal')
);
const InsufficientBalanceModal = lazy(() =>
  import('components/InsufficientBalanceModal/InsufficientBalanceModal')
);
const JoinFanclubModal = lazy(() =>
  import('components/JoinFanclubModal')
);
const LoginV2Modal = lazy(() =>
  import('components/LoginV2Modal/LoginV2Modal')
);
const LoginV2AccountExpiredModal = lazy(() =>
  import('components/LoginV2AccountExpiredModal/LoginV2AccountExpiredModal')
);
const LoginV2SecurityQuestionFormModal = lazy(() =>
  import('components/LoginV2SecurityQuestionFormModal/LoginV2SecurityQuestionFormModal')
);
const LoginV2TwoFaModal = lazy(() =>
  import('components/LoginV2TwoFaModal/LoginV2TwoFaModal')
);
const LoginV2UnverifiedUserFormModal = lazy(() =>
  import('components/LoginV2UnverifiedUserFormModal/LoginV2UnverifiedUserFormModal')
);
const MoreInfoAboutIDModal = lazy(() =>
  import('components/MoreInfoAboutIDModal/MoreInfoAboutIDModal')
);
const NeedsIdModal = lazy(() =>
  import('components/CashOutRestrictedOrNeedsIdModal/NeedsIdModal')
);
const NewNoteModal = lazy(() =>
  import('pages/Broadcaster/Modals/NewNoteModal/NewNoteModal')
);
const OnboardingEmergencyModal = lazy(() =>
  import('components/OnboardingEmergencyModal/OnboardingEmergencyModal')
);
const PasswordResetV2Modal = lazy(() =>
  import('components/PasswordResetV2Modal/PasswordResetV2Modal')
);
const PerformerGoalDesktop = lazy(() =>
  import('components/PerformerGoalDesktop/PerformerGoalDesktop')
);
const PredefinedTagsModal = lazy(() =>
  import('pages/Broadcaster/Modals/PredefinedTagsModal/PredefinedTagsModal')
);
const PrivateDirectoryModalCall = lazy(() =>
  import('pages/PrivateDirectory/components/Modal/PrivateDirectoryModalCall')
);
const PrivateDirectoryModalInAnotherCall = lazy(() =>
  import('pages/PrivateDirectory/components/Modal/PrivateDirectoryModalInAnotherCall')
);
const PrivateDirectoryModalMessage = lazy(() =>
  import('pages/PrivateDirectory/components/Modal/PrivateDirectoryModalMessage')
);
const PrivateDirectoryModalViewMore = lazy(() =>
  import('pages/PrivateDirectory/components/Modal/PrivateDirectoryModalViewMore')
);
const PrivateMessageModalV2 = lazy(() =>
  import('components/PrivateMessageModalV2/PrivateMessageModalV2')
);
const PrivateShowConfirmationModal = lazy(() =>
  import('components/PrivateShowConfirmationModal/PrivateShowConfirmationModal')
);
const PrivateTipModal = lazy(() =>
  import('components/PrivateTipModal/PrivateTipModal')
);
const ProfileV2FeedbackModal = lazy(() =>
  import('components/ProfileV2FeedbackModal/ProfileV2FeedbackModal')
);
const PSSettingsModal = lazy(() =>
  import('pages/Broadcaster/Modals/PSSettingsModal/PSSettingsModal')
);
const RegionalPackagesModal = lazy(() =>
  import('components/RegionalPackagesModal/RegionalPackagesModal')
);
const RegistrationGoldModal = lazy(() =>
  import('components/RegistrationGoldModal/RegistrationGoldModal')
);
const RegistrationModal = lazy(() =>
  import('pages/RegistrationModal/RegistrationModal')
);
const RequestPrivateShowModal = lazy(() =>
  import('components/RequestPrivateShowModal/RequestPrivateShowModal')
);
const RemoveBroadcasterFromListModal = lazy(() =>
  import('components/RemoveBroadcasterFromListModal/RemoveBroadcasterFromListModal')
);
const SendGiftModal = lazy(() =>
  import('components/SendGiftModal/SendGiftModal')
);
const SendQuickGiftModal = lazy(() =>
  import('components/SendQuickGiftModal/SendQuickGiftModal')
);
const SendTweetModal = lazy(() =>
  import('components/BroadcasterTwitter/SendTweetModal')
);
const SetAsDefaultProcessorModal = lazy(() =>
  import('pages/PerformerPayment/common/SetAsDefaultProcessorModal')
);
const SFWImageModal = lazy(() =>
  import('components/SFWImageModal/SFWImageModal')
);
const ShowInviteModal = lazy(() =>
  import('components/ShowInviteModal/ShowInviteModal')
);
const SpeedTestModal = lazy(() =>
  import('pages/Broadcaster/Modals/SpeedTestModal/SpeedTestModal')
);
const TipMenuModal = lazy(() =>
  import('components/TipMenuModal/TipMenuModal')
);
const TokenAwarenessMobile = lazy(() =>
  import('components/TokenAwarenessMobile/TokenAwarenessMobile')
);
const TokenHoldersAllowedModal = lazy(() =>
  import('components/TokenHoldersAllowedModal/TokenHoldersAllowedModal')
);
const TwitterConnectAccountModal = lazy(() =>
  import('components/BroadcasterTwitter/TwitterConnectAccountModal')
);
const UnlinkProcessorModal = lazy(() =>
  import('pages/PerformerPayment/common/UnlinkProcessorModal')
);
const UpgradeToGoldModalV2 = lazy(() =>
  import('components/UpgradeToGoldModalV2/UpgradeToGoldModalV2')
);
const UpgradeToGoldContextual = lazy(() =>
  import('components/UpgradeToGoldContextual/UpgradeToGoldContextual')
);
const VideoOverlay = lazy(() =>
  import('components/VideoOverlay/VideoOverlay')
);
const WeakPasswordModal = lazy(() =>
  import('components/WeakPasswordModal/WeakPasswordModal')
);
const AddImagesModal = lazy(() =>
  import('pages/PerformerHub/fanZone/Media/AddImagesModal')
);
const ConfirmationModal = lazy(() =>
  import('components/ConfirmationModal')
);
const VideoPreviewModal = lazy(() =>
  import('pages/PerformerHub/fanZone/Media/VideoPreviewModal')
);
const VideoCoverModal = lazy(() =>
  import('pages/PerformerHub/fanZone/Media/VideoCoverModal')
);
const AddMediaModal = lazy(() =>
  import('pages/PerformerHub/fanZone/Media/AddMediaModal')
);
const ShareMediaModal = lazy(() =>
  import('pages/PerformerHub/fanZone/Media/ShareMediaModal')
);
const EditMediaModal = lazy(() =>
  import('pages/PerformerHub/fanZone/Media/EditMediaModal')
);
const AutoTweetImageModal = lazy(() =>
  import('pages/PerformerHub/fanZone/SmartMessages/AddImageModal')
);
const GuestContentOverlay = lazy(() =>
  import('pages/UserProfile/FanClub/MediaSection/Overlays/GuestContentOverlay')
);


const MODALS_REFFERENCES = {
  ADD_BROADCASTER_TO_SPONSORED_TAG_MODAL: AddBroadcasterToSponsoredTagModal,
  ADD_NEW_TAG_MODAL: AddNewTagModal,
  ADD_STUDIO_BROADCASTERS_TO_TAG_MODAL: AddStudioBroadcastersToTagModal,
  ADMIN_BANNED_USER_ACCOUNT: AdminBannedUserModal,
  ADMIN_BULK_BAN_MODAL: AdminBulkBanModal,
  ADMIN_CONFIRM_MODAL: AdminConfirmModal,
  ADMIN_CSV_MESSAGES_MODAL: AdminCsvMessagesModal,
  ADMIN_LANGUAGE_OVERRIDE_MODAL: AdminLanguageOverrideModal,
  ALL_AWARDS: AwardsModal,
  ALL_GIFTS_MODAL: AllGiftsModal,
  AUTO_RELOAD_MODAL: AutoReloadModal,
  BASIC_REDIRECT_ONBOARDING_MODAL: BasicRedirectOnboardingModal,
  BEAT_THE_LEADER: BeatTheLeaderModal,
  BEAT_TIP_LEADER_MODAL: BeatTipLeaderModal,
  BOOST_MODAL: BoostModal,
  BROADCASTER_CONNECT_TOY_MODAL: BroadcasterConnectToyModal,
  BROADCASTER_END_PRIVATE_SHOW_MODAL: BroadcasterEndPrivateShowModal,
  BROADCASTER_GROUP_SHOW_CANCEL: BroadcasterCancelGroupShowModal,
  BROADCASTER_GROUP_SHOW_GOAL_REACHED: BroadcasterTicketGoalReachedModal,
  BROADCASTER_GROUP_SHOW_LAST_CHANCE: BroadcasterGroupShowLastChance,
  BROADCASTER_GROUP_SHOW_TIME_REACHED: BroadcasterGroupShowTimeReachedModal,
  BROADCASTER_MESSAGE_DISABLED_MODAL: BroadcasterMessageDisabledModal,
  BROADCASTER_PS_ENDED_RATING_MODAL: BroadcasterPSEndedRatingModal,
  BROADCASTER_WINDOW_INTRODUCTION_MODAL: BroadcasterWindowIntroductionModal,
  BROADCASTING_CONSENT_MODAL: BroadcastingConsentModal,
  BROADCAST_END_MODAL: BroadcastEndModal,
  BROADCAST_ERROR_MODAL: BroadcastErrorModal,
  BROADCAST_MOBILE_CONSENT_MODAL: BroadcastMobileConsentModal,
  BROADCAST_OBS_VIRTUAL_CAMERA_WARNING_MODAL: BroadcastOBSVirtualCameraWarningModal,
  BROADCAST_TYPE_ONBOARDING_MODAL: BroadcastTypeOnboardingModal,
  BUY_ALL_VIDEOS_MODAL: BuyAllVideosModal,
  BUY_GIFTS_MODAL: BuyGiftsModal,
  CAMPAIGN_OVERLAY_MOBILE: CampaignOverlayMobile,
  CASH_OUT_RESTRICTED_MODAL: CashOutRestrictedModal,
  CHAT_CONTEXTUAL_MENU_BAN: ChatContextualMenuBan,
  CHAT_CONTEXTUAL_MENU_CLOSE_ROOM: ChatContextualMenuCloseRoom,
  CHAT_CONTEXTUAL_MENU_CONFIRM_OPTION: ChatContextualMenuConfirmOption,
  CHAT_CONTEXTUAL_MENU_DELETE_KICK: ChatContextualMenuDeleteKick,
  CHAT_CONTEXTUAL_MENU_FAN_BAN: ChatContextualMenuFanBan,
  CHAT_CONTEXTUAL_MENU_FAN_PERMA_BAN: ChatContextualMenuFanPermaBan,
  CHAT_CONTEXTUAL_MENU_FEATURE_BROADCASTER: ChatContextualMenuFeatureBroadcaster,
  CHAT_CONTEXTUAL_MENU_KICK: ChatContextualMenuKick,
  CHAT_CONTEXTUAL_MENU_PERMA_BAN: ChatContextualMenuPermaBan,
  CHAT_CONTEXTUAL_MENU_REPORT: ChatContextualMenuReport,
  CHAT_CONTEXTUAL_OVERLAY: ChatContextualOverlay,
  CLOSE_CONVERSATION_MODAL: CloseConversationModal,
  CONTINUE_PURCHASE_OR_JOIN_FANCLUB_MODAL: ContinuePurchaseOrJoinFanclubModal,
  COOMING_SOON_MODAL: ComingSoonModal,
  DELETE_COMMENT_MODAL: DeleteCommentModal,
  DELETE_MODAL: DeleteModal,
  DELETE_SPONSORED_TAG_MODAL: DeleteSponsoredTagModal,
  DESKTOP_COMPLETE_GOAL_MODAL: PerformerGoalDesktop,
  DISABLE_SHOW_INVITES_MODAL: DisableShowInvitesModal,
  DMCA_SUBMIT_MODAL: DMCASubmitModal,
  ERROR_MODAL: ErrorModal,
  GIFT_CATEGORY_MODAL: GiftCategoryModal,
  GIFT_MODAL: GiftModal,
  GROUP_SHOW_BUY_TICKET_MODAL: GroupShowBuyTicketModal,
  GROUP_SHOW_CANCELED_MODAL: GroupShowCanceledModal,
  GROUP_SHOW_GOAL_MODAL: GroupShowGoalModal,
  GROUP_SHOW_GOAL_REACHED_MODAL: GroupShowGoalReachedModal,
  GS_SETTINGS_MODAL: BroadcasterGSSettingsModal,
  GUEST_BILLING_MODAL: GuestBillingModal,
  GUEST_REGISTRATION_MODAL: GuestRegistrationModal,
  INFORM_MULTIPLE_IDENTITIES_ONBOARDING_MODAL: InformMultipleIdentitiesOnboardingModal,
  INFORM_PENDING_ONBOARDING_MODAL: InformPendingOnboardingModal,
  INSUFFICIENT_BALANCE_MODAL: InsufficientBalanceModal,
  JOIN_FAN_CLUB_MODAL: JoinFanclubModal,
  LOGIN_MODAL_V2: LoginV2Modal,
  LOGIN_V2_2FA_MODAL: LoginV2TwoFaModal,
  LOGIN_V2_ACCOUNT_EXPIRED_MODAL: LoginV2AccountExpiredModal,
  LOGIN_V2_SECURITY_QUESTION_FORM_MODAL: LoginV2SecurityQuestionFormModal,
  LOGIN_V2_UNVERIFIED_USER_MODAL: LoginV2UnverifiedUserFormModal,
  MORE_INFO_ABOUT_ID_MODAL: MoreInfoAboutIDModal,
  MY_SHOP_VIDEO_MODAL: VideoOverlay,
  NEEDS_ID_MODAL: NeedsIdModal,
  NEW_NOTE_MODAL: NewNoteModal,
  ONBOARDING_EMERGENCY_MODAL: OnboardingEmergencyModal,
  ONE_CLICK_RETENTION_MODAL: OneClickRetentionModal,
  PASSWORD_RESET_V2_MODAL: PasswordResetV2Modal,
  PREDEFINED_TAGS_MODAL: PredefinedTagsModal,
  PRIVATE_DIRECTORY_MODAL_CALL: PrivateDirectoryModalCall,
  PRIVATE_DIRECTORY_MODAL_IN_ANOTHER_CALL: PrivateDirectoryModalInAnotherCall,
  PRIVATE_DIRECTORY_MODAL_MESSAGE: PrivateDirectoryModalMessage,
  PRIVATE_DIRECTORY_VIEW_MORE: PrivateDirectoryModalViewMore,
  PRIVATE_MESSAGE_MODAL: PrivateMessageModalV2,
  PRIVATE_SHOW_CONFIRMATION_MODAL: PrivateShowConfirmationModal,
  PRIVATE_TIP_MODAL: PrivateTipModal,
  PROFILE_V2_FEEDBACK_MODAL: ProfileV2FeedbackModal,
  PROMO_OVERLAY: TokenAwarenessMobile,
  PS_SETTINGS_MODAL: PSSettingsModal,
  REGIONAL_PACKAGES_MODAL: RegionalPackagesModal,
  REGISTRATION_GOLD_MODAL: RegistrationGoldModal,
  REGISTRATION_MODAL: RegistrationModal,
  REMOVE_BROADCASTER_FROM_LIST_MODAL: RemoveBroadcasterFromListModal,
  REQUEST_PRIVATE_SHOW_MODAL: RequestPrivateShowModal,
  SAFARI_14_MODAL: Safari14Modal,
  SEND_GIFT_MODAL: SendGiftModal,
  SEND_QUICK_GIFT_MODAL: SendQuickGiftModal,
  SEND_TWEET_MODAL: SendTweetModal,
  SEND_USER_GIFT_MODAL: SendUserGiftModal,
  SET_AS_DEFAULT_PROCESSOR_MODAL: SetAsDefaultProcessorModal,
  SFW_IMAGE_MODAL: SFWImageModal,
  SHAFT_TRAFFIC_ADS_MODAL: ShaftTrafficAdsModal,
  SHOW_INVITE_MODAL: ShowInviteModal,
  SPEED_TEST_MODAL: SpeedTestModal,
  TIP_MENU_MODAL: TipMenuModal,
  TOKEN_HOLDERS_ALLOWED_MODAL: TokenHoldersAllowedModal,
  TWITTER_CONNECT_ACCOUNT_MODAL: TwitterConnectAccountModal,
  UNLINK_PROCESSOR_MODAL: UnlinkProcessorModal,
  UPGRADE_TO_GOLD_CONTEXTUAL: UpgradeToGoldContextual,
  UPGRADE_TO_GOLD_MODAL_V2: UpgradeToGoldModalV2,
  WEAK_PASSWORD_MODAL: WeakPasswordModal,
  PORNDOE_MODAL: PorndoeModal,
  NON_PURCHASED_OVERLAY: NonPurchasedOverlay,
  FANCLUB_VIDEO_OVERLAY: FanclubVideoOverlay,
  ADD_IMAGES_MODAL: AddImagesModal,
  CONFIRMATION_MODAL: ConfirmationModal,
  FANCLUB_VIDEO_PREVIEW_MODAL: VideoPreviewModal,
  VIDEO_COVER_MODAL: VideoCoverModal,
  ADD_MEDIA_MODAL: AddMediaModal,
  SHARE_MEDIA_MODAL: ShareMediaModal,
  EDIT_MEDIA_MODAL: EditMediaModal,
  AUTOTWEET_IMAGE_MODAL: AutoTweetImageModal,
  GUEST_CONTENT_OVERLAY: GuestContentOverlay,
  WEBRTC_OBS_MEDIA_NOT_SUPPORTED: WebRTCOBSIncorrectConfigModal,
};

class ModalRenderer extends React.Component {
  state = { activeModal: null };

  componentDidMount() {
    ModalService.addChangeListener(this.onModalServiceChanged);
  }

  componentWillUnmount() {
    ModalService.removeChangeListener(this.onModalServiceChanged);
  }

  onModalServiceChanged = (activeModal) => this.setState({ activeModal });

  render() {
    const { activeModal } = this.state;

    if (activeModal && activeModal.modalKey && activeModal.modalProps) {
      const ModalComponent = MODALS_REFFERENCES[activeModal.modalKey];
      if (ModalComponent) {
        return (
          <ModalComponent
            close={ModalService.hideModal}
            show={true}
            {...activeModal.modalProps}
          />
        );
      }
      // eslint-disable-next-line no-console
      console.error(
        `ModalRenderer cannot find modal refference with modalKey=${activeModal.modalKey} in MODALS_REFFERENCES object`
      );
    }

    return null;
  }
}

export default ModalRenderer;
